module.exports = __webpack_public_path__ + "img/SummaryBanner.2b51385e.svg";